export default "__VITE_ASSET__Cf9U0Ea3__"